// Badge «indirizzo incompleto» in testata della pagina ordine (item 15).
//
// Nasce dall'ordine 2001719785-A: entrato senza provincia, Poleepo non riesce a
// creare la LDV — e l'operatore se ne accorge solo al momento di spedire.
// Detection-only: OM NON scrive su Poleepo (`PUT /orders` duplica l'ordine,
// hotfix 1.1.20), quindi l'indirizzo va corretto sul marketplace di origine.
import type { Order } from "../../types";

const ISSUE_LABELS: Record<string, string> = {
  destinatario: "destinatario",
  indirizzo: "indirizzo",
  citta: "città",
  cap: "CAP",
  provincia: "provincia",
  cap_provincia_incoerenti: "CAP/provincia incoerenti",
  // Ordine 445609: "0427/808036" da WooCommerce, SDA risponde "il telefono e'
  // un campo numerico" — ma solo DOPO che Poleepo ha creato la spedizione,
  // che resta lì senza etichetta. Va corretto alla fonte: OM non può
  // riscrivere il destinatario su Poleepo.
  telefono: "telefono non numerico",
};

export function AddressIssuesBadge({ order }: { order: Order }) {
  const issues = order.addressIssues ?? [];
  if (issues.length === 0) return null;
  const labels = issues.map((issue) => ISSUE_LABELS[issue] ?? issue);

  // Fondo pieno + testo bianco come gli altri badge di questa pagina: la coppia
  // `bg-X-soft` + `text-X` non passa il contrasto WCAG in questa palette.
  return (
    <span
      data-testid="address-issues-badge"
      title={`Poleepo non potrà creare la lettera di vettura finché l'indirizzo non è completo. Da sistemare sul marketplace: ${labels.join(", ")}.`}
      className="inline-flex shrink-0 items-center gap-1 rounded-full bg-red px-2 py-px text-[10px] font-semibold uppercase tracking-[0.04em] text-white"
    >
      Indirizzo: {labels.join(", ")}
    </span>
  );
}
